import { useCallback, useContext } from "react";
import {
    QrCodeActions,
    ResponseContext,
    SwiggyContextHeader,
    TableContext,
    usePlApiContextFetch,
} from "@swiggy-private/portal-dineout-context";
import type { CrossSellConfig } from "@swiggy-private/portal-dineout-context";
import { API_ENDPOINTS, GANDALF_API_HOST, LOG_TABLES, NR_TABLES } from "../constants";
import { API_DEFAULT_HEADERS, getDefaultApiHeaders } from "../utils/api";
import { sendCustomNREvViaBlaze } from "../utils/newrelic";

type CrossSellSuccessPayload = {
    cards?: Array<{ card?: { card?: CrossSellConfig } }>;
};

export const useFetchCrossSellConfig = () => {
    const fetchPL = usePlApiContextFetch();
    const { swiggyHeaders } = useContext(SwiggyContextHeader);
    const { restaurantId = "", tableId = "", parentOrderId = "" } = useContext(TableContext);
    const { state, dispatch } = useContext(ResponseContext);

    const fetchCrossSellConfig = useCallback(async () => {
        if (state.crossSell?.config || !restaurantId || !tableId || !fetchPL) return;

        const headers = { ...swiggyHeaders, ...getDefaultApiHeaders(swiggyHeaders) };

        try {
            const data = await fetchPL?.<CrossSellSuccessPayload>(
                {
                    apiHost: GANDALF_API_HOST,
                    endpoint: API_ENDPOINTS.CROSS_SELL_PL_API,
                    bodyParams: { restaurant_id: restaurantId, table_id: tableId, parent_order_id: parentOrderId },
                    searchParams: {
                        lat: API_DEFAULT_HEADERS.lat,
                        lng: API_DEFAULT_HEADERS.lng,
                    },
                    options: {
                        method: "POST",
                        headers: headers as HeadersInit,
                    },
                },
                headers,
                () => {},
                LOG_TABLES,
            );

            const config = data?.success?.cards?.[0]?.card?.card;
            if (config?.crossSell) {
                dispatch({ type: QrCodeActions.CROSS_SELL_CONFIG_LOADED, payload: config });
            }
        } catch {
            sendCustomNREvViaBlaze(NR_TABLES.CROSS_SELL_CONFIG_FETCH_ERROR, {}, swiggyHeaders ?? {});
        }
    }, [restaurantId, tableId, parentOrderId, fetchPL, swiggyHeaders, state.crossSell?.config, dispatch]);

    return { fetchCrossSellConfig };
};
